import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from "next-seo";
import React from "react";
import RoundedButton from "components/RoundedButton";

const NhsTicketsArticle = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/30000-free-event-tickets-for-nhs-and-frontline-workers`;

  return (
    <MainLayout>
      <NextSeo
        title="30,000 Free Event Tickets For NHS & Frontline Workers Thanks To New DAYMADE & Tickets For Good Partnership | DAYMADE"
        description="DAYMADE has teamed up with Tickets for Good to secure 30,000 free tickets for live events nationwide for NHS and frontline workers"
        openGraph={{
          title: "30,000 Free Event Tickets For NHS & Frontline Workers Thanks To New DAYMADE & Tickets For Good Partnership | DAYMADE",
          description: "DAYMADE has teamed up with Tickets for Good to secure 30,000 free tickets for live events nationwide for NHS and frontline workers",
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/30000-free-event-tickets-for-nhs-and-frontline-workers',
          images: [{
            url: `${IMAGE_DIRECTORY}/hero.jpg`,
            alt: 'Audience members making heart sign with their hands at a live music concert'
          }]
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'charity,raffle,events,nhs,frontline,support,giving back,partnership,win,travel,holiday,raffle'
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="Audience members making heart sign with their hands at a live music concert"
      >
        <>
          <h1 style={{ fontSize: '1.6em' }}>
            30,000 Free Event Tickets For <strong>NHS & Frontline Workers</strong>
          </h1>

          <p className='subheading'>
            thanks to new DAYMADE & Tickets for Good partnership
          </p>

          <div className='separator' style={{ width: '80%', marginTop: 0 }} />

          <p>
            <span className='bigFirstLetter'>D</span>AYMADE has teamed up with <a href='https://www.ticketsforgood.co.uk' target='_blank' style={{ fontWeight: 'bold', margin: 0 }}>Tickets for Good</a>, a ticketing service which aims to connect social life with social good, to raise funds for the Giving Back Campaign. Its goal is to secure 30,000 free tickets for live events nationwide for NHS and frontline workers.
          </p>

          <p>
            The Giving Back Campaign was created in July 2020 by Tickets for Good as a means of showing appreciation to NHS and frontline staff who have been working selflessly throughout the Covid-19 pandemic, while also supporting the struggling live entertainment sector. The new partnership has two aims: to encourage performance and sports venues as well as event management companies and ticket providers, big and small, throughout the UK, to donate tickets to the Campaign, while persuading consumers to raise funds by entering a special Giving Back Charity Raffle, run by DAYMADE. The initial goal is to provide 30,000 tickets, but the sky is the limit. The tickets will be free to NHS and frontline workers, apart from a small booking fee of £3.50.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt='Wall art showing an NHS worker with a face mask making a heart with her hands'
            className='singleBlogImage'
            style={{
              maxWidth: '500px'
            }}
          />

          <p>
            Consumers can donate by entering our Giving Back Charity Raffle and buying a ticket for £2.00 to win a range of epic experience prizes including a Flight Lesson, a Zipline Adventure for 2, a Murder Mystery Hotel break for 2 or a Hot Tug ride through the London canals. Multiple tickets can be purchased. All profits from the raffle will go to the Giving Back campaign and the purchase of event tickets. The draw takes place on the third Tuesday of each month, starting in October 2020.
          </p>

          <p>
            Tickets for Good was created in 2017 by Steve Rimmer to ensure that people with needs have access to cultural events regardless of their wealth or social inclusion. It operates as a ticket and CSR (corporate social responsibility) platform that uses spare capacity in the live events space to create life-changing experiences for people in need.
          </p>

          <p>
            Steve Rimmer commented: “Via our partnership with DAYMADE, Tickets for Good is now using its platform to donate tickets to NHS and frontline workers as a way to say thank you for their hard work. Medical professionals and our own clinical research highlight how live event attendance creates benefits for many. We hope performance and sports venues, event management companies and ticket providers will come on board with us to make this a success. Our mission is to use unsold tickets, and the funds raised by the Giving Back Campaign to improve the wellbeing of others and increase the viability of live events.”
          </p>

          <div className='doubleImageContainer'>
            <img
              src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
              alt="Child's colourful drawing on a rainbow accompanied by the writing: thank you key workers"
              className='doubleBlogImage'
            />

            <img
              src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
              alt='Woman with arms thrown up in the air at sunset in a festival campsite'
              className='doubleBlogImage'
            />
          </div>

          <p>
            Lisa Nederveen, co-founder at DAYMADE, which has teamed up with Tickets for Good as their exclusive partner, added: “Working with Tickets for Good on our Giving Back Campaign Charity Raffle came as a natural fit. Experiences, travel and entertainment are at the heart of what we do. With every raffle ticket purchased, contributors get a chance to win an epic experience while helping to give NHS and frontline workers a fabulous experience as well. There are no losers in this raffle!”
          </p>

          <p>
            She continued: “In April we launched a Charity Raffle and raised over £3,000 for Covid- 19 relief which was donated to NHS Charities Together, Save Our Children UK and Trussell Trust, helping to support them in these challenging times.”
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary4.jpg`}
            alt='View of theatre stage with traditional red curtain hanging down'
            className='singleBlogImage'
            style={{
              maxWidth: '500px'
            }}
          />

          <RoundedButton href='/' style={{ textTransform: 'uppercase' }}>
            Enter Draw
          </RoundedButton>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default NhsTicketsArticle;
